

export class LetterEntitiesDto implements ILetterEntitiesDto {
    letterName!: string | undefined;
    letterCode!: string | undefined;

    constructor(data?: ILetterEntitiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.letterName = _data["letterName"];
            this.letterCode = _data["letterCode"];
        }
    }

    static fromJS(data: any): LetterEntitiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new LetterEntitiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["letterName"] = this.letterName;
        data["letterCode"] = this.letterCode;
        return data; 
    }
}

export interface ILetterEntitiesDto {
    letterName: string | undefined;
    letterCode: string | undefined;
}

